import FirestoreDataClass from "./_baseClasses";

export default class UserSubscriptionLink extends FirestoreDataClass {
  static collectionName = "user_subscription_links";
}
